import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_auth/dashboard/organizations/$organizationId/projects/$projectVersionId/',
)({
    component: RouteComponent,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/dashboard/organizations/$organizationId/projects/$projectVersionId/documents',
            params,
        });
    },
});

function RouteComponent() {
    return null;
}
